import {
	Button,
	Card,
	CardBody,
	StringHelpers,
	useLangContext,
	BottomAnchoredControls,
	WidthConstrainedContainer,
} from 'carrier-fe';
import FailIcon from '../icons/fail';
import { useNavigate, useParams } from 'react-router-dom';

function QuizFail(props: { maxWidth: number }) {
	const { id } = useParams();
	const navigate = useNavigate();
	const { quiz } = useLangContext();
	const { maxWidth } = props;

	return (
		<>
			<WidthConstrainedContainer maxWidth={maxWidth}>
				<Card>
					<CardBody>
						<div className="text-center">
							<FailIcon />
							<h1>
								{StringHelpers.title(
									quiz?.failed || 'Quiz Failed'
								)}
							</h1>
							<p>{quiz.failed_subtitle || ''}</p>
						</div>
					</CardBody>
				</Card>
			</WidthConstrainedContainer>
			<BottomAnchoredControls>
				<Button
					label={StringHelpers.title(quiz.close || 'Close')}
					onClick={() => navigate(`/training/course/${id}/progress`)}
				/>
			</BottomAnchoredControls>
		</>
	);
}

export default QuizFail;
